// extracted by mini-css-extract-plugin
export var notificationHost = "_mm-0";